import { Action } from 'redux';
import { Epic } from 'redux-observable';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import { concat as concat$ } from 'rxjs/observable/concat';
import { from as from$ } from 'rxjs/observable/from';

import {
    ACTION_SOURCEDOCUMENTSFORMS_CLEAR,
    ACTION_SOURCEDOCUMENTSFORMS_LOAD,
    ACTION_SOURCEDOCUMENTSFORMS_LOAD_BY_ID,
    ACTION_SOURCEDOCUMENTSFORMS_LOAD_BY_PATIENT_ID,
    ACTION_SOURCEDOCUMENTSFORMS_LOAD_BY_PATIENT_IDENTIFIER,
    ACTION_SOURCEDOCUMENTSFORMS_LOAD_FAILURE,
    ACTION_SOURCEDOCUMENTSFORMS_LOAD_SUCCESS,

    ACTION_SOURCEDOCUMENTSFORMS_SAVE,
    ACTION_SOURCEDOCUMENTSFORMS_SAVE_FAILURE,
    ACTION_SOURCEDOCUMENTSFORMS_SAVE_SUCCESS,

    ACTION_SOURCEDOCUMENTSFORMS_CREATE,
    ACTION_SOURCEDOCUMENTSFORMS_CREATE_SUCCESS,
    ACTION_SOURCEDOCUMENTSFORMS_CREATE_FAILURE,

    ISourceDocumentsFormLoadAction,
    ISourceDocumentsFormClearAction,
    ISourceDocumentsFormLoadByIdAction,
    ISourceDocumentsFormLoadByPatientIdAction,
    ISourceDocumentsFormLoadByPatientIdentifierAction,
    ISourceDocumentsFormLoadFailureAction,
    ISourceDocumentsFormLoadSuccessAction,

    ISourceDocumentsFormSaveAction,
    ISourceDocumentsFormSaveSuccessAction,
    ISourceDocumentsFormSaveFailureAction,

    ISourceDocumentsFormCreateAction,
    ISourceDocumentsFormCreateSuccessAction,
    ISourceDocumentsFormCreateFailureAction,

    LoadSuccess,
    LoadFailure,

    SaveSuccess,
    SaveFailure,

    CreateSuccess,
    CreateFailure


} from "../../actions/forms/sourceDocumentsForm";

import { sourceDocumentsFormApi } from "../../services/Forms/sourceDocumentsForm";


export const
    getSourceDocumentsFormsEpic = (action$): Observable<ISourceDocumentsFormLoadSuccessAction | ISourceDocumentsFormLoadFailureAction> => {
        return action$
            .ofType(ACTION_SOURCEDOCUMENTSFORMS_LOAD)
            .mergeMap((action: ISourceDocumentsFormLoadAction) => {
                return sourceDocumentsFormApi
                    .getSourceDocumentsForms()
                    .map(response =>
                        LoadSuccess(response.sourceDocumentsForms, undefined, undefined, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getSourceDocumentsFormsByIdEpic = (action$): Observable<ISourceDocumentsFormLoadSuccessAction | ISourceDocumentsFormLoadFailureAction> => {
        return action$
            .ofType(ACTION_SOURCEDOCUMENTSFORMS_LOAD_BY_ID)
            .mergeMap((action: ISourceDocumentsFormLoadByIdAction) => {
                return sourceDocumentsFormApi
                    .getSourceDocumentsFormById(action.id)
                    .map(response =>
                        LoadSuccess(response.sourceDocumentsForm, response.registrationFormState, response.registrationFormProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getSourceDocumentsFormsByPatientIdEpic = (action$): Observable<ISourceDocumentsFormLoadSuccessAction | ISourceDocumentsFormLoadFailureAction> => {
        return action$
            .ofType(ACTION_SOURCEDOCUMENTSFORMS_LOAD_BY_PATIENT_ID)
            .mergeMap((action: ISourceDocumentsFormLoadByPatientIdAction) => {
                return sourceDocumentsFormApi
                    .getSourceDocumentsFormByPatientId(action.patientId)
                    .map(response =>
                        LoadSuccess(response.sourceDocumentsForm, response.registrationFormState, response.registrationFormProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getSourceDocumentsFormsByPatientIdentifierEpic = (action$): Observable<ISourceDocumentsFormLoadSuccessAction | ISourceDocumentsFormLoadFailureAction> => {
        return action$
            .ofType(ACTION_SOURCEDOCUMENTSFORMS_LOAD_BY_PATIENT_IDENTIFIER)
            .mergeMap((action: ISourceDocumentsFormLoadByPatientIdentifierAction) => {
                return sourceDocumentsFormApi
                    .getSourceDocumentsFormByPatientIdentifier(action.identifier)
                    .map(response =>
                        LoadSuccess(response.sourceDocumentsForm, response.registrationFormState, response.registrationFormProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setSourceDocumentsFormsEpic = (action$): Observable<ISourceDocumentsFormSaveSuccessAction | ISourceDocumentsFormSaveFailureAction> => {
        return action$
            .ofType(ACTION_SOURCEDOCUMENTSFORMS_SAVE)
            .mergeMap((action: ISourceDocumentsFormSaveAction) => {
                return sourceDocumentsFormApi
                    .setSourceDocumentsForm(action.formData, action.institutionCode, action.patientIdentifier)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.sourceDocumentsForm, response.registrationFormState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    createSourceDocumentsFormsEpic = (action$): Observable<ISourceDocumentsFormCreateSuccessAction | ISourceDocumentsFormCreateFailureAction> => {
        return action$
            .ofType(ACTION_SOURCEDOCUMENTSFORMS_CREATE)
            .mergeMap((action: ISourceDocumentsFormCreateAction) => {
                return sourceDocumentsFormApi
                    .createSourceDocumentsForm()
                    .map(response =>
                        CreateSuccess(response.sourceDocumentsForm, response.registrationFormState, response.registrationFormProperties, response.lookups)
                    )
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    }





